import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates, TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';

import { useApplicationContext } from '../../../../../utils/applicationContext';
import { TgbNativedescGeneralContainer } from '../TgbNativedescGeneral';

type AdFoxTemplatesParams = TTgbNativedescGeneralContext;

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES = Array.of<AdFoxTemplatesParams['type']>('tgb_nativedesc_general');

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const { bundleName, bundleParams, height } = props;

  const { logger } = useApplicationContext();

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          if (OWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'tgb_nativedesc_general':
                return <TgbNativedescGeneralContainer height={height} context={parsedDecodedParams} />;
            }
          }
        }
      } catch (e) {
        logger.error(e, {
          bannerId: bundleParams.bannerId,
          domain: 'src/shared/components/AdfoxBannerComponent/internal/components/OwnTemplates/OwnTemplates.tsx',
          message: '[AdFox] Failed to decode/parse bundleParams',
        });

        return null;
      }
    }
  }

  return <AdFoxTemplates deviceType="desktop" {...props} />;
};

function isParsedParamsValid(params: object): params is AdFoxTemplatesParams {
  return 'type' in params;
}
